import { Tchek } from "./tchek";
import { Client } from "./client";
import { TchekUser } from "./user";

export class Activity {
  type: number;
  tchekPtr: Tchek;
  clientPtr: Client;
  userPtr: TchekUser;
  id: string;
  date: Date;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/model/activity.ts